import React, { useMemo } from "react"

import { useStyles } from "@/components/CampaignActionCardTracker/styles"
import { ActionItem } from "@/components/CampaignActionCardTracker/ActionItem"
import { transpileCampaignValueToCampaignType } from "@/components/CampaignActionCardTracker/helper"

interface CampaignActionCardCounterTrackerProps {
    selectedCampaignTypeValues: number[]
}

export const CampaignActionCardTracker = (props: CampaignActionCardCounterTrackerProps) => {
    const { classes } = useStyles()

    const selectedCampaignTypes = useMemo(() => {
        return props.selectedCampaignTypeValues.map((key) => transpileCampaignValueToCampaignType(key))
    }, [props.selectedCampaignTypeValues])

    return (
        <section className={classes.container}>
            <ActionItem
                position="1st"
                icon={selectedCampaignTypes[0]?.new_icon}
                iconFamily={selectedCampaignTypes[0]?.icon_family}
                title={selectedCampaignTypes[0]?.label}
            />
            <hr className={classes.divisor} />
            <ActionItem
                position="2nd"
                icon={selectedCampaignTypes[1]?.new_icon}
                iconFamily={selectedCampaignTypes[1]?.icon_family}
                title={selectedCampaignTypes[1]?.label}
            />
            <hr className={classes.divisor} />
            <ActionItem
                position="3rd"
                icon={selectedCampaignTypes[2]?.new_icon}
                iconFamily={selectedCampaignTypes[2]?.icon_family}
                title={selectedCampaignTypes[2]?.label}
            />
        </section>
    )
}
